import { Location } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-under-maintenance',
  templateUrl: './under-maintenance.component.html',
  styleUrls: ['./under-maintenance.component.scss']
})
export class UnderMaintenanceComponent implements OnInit {
  @Input() childLinkLabel = 'Administration';
  @Input() subchildLinkLabel = 'Notification Message Setup';
  constructor(
    private _location: Location
  ) { }

  ngOnInit(): void {
  }

  backToPreviousPage() {
    this._location.back();
  }
}
